var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignedScheduleA({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M0 0v24.945h24V0H0zm22.67 4.059V23.616H1.33V1.329h21.34v2.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M14.002 5.17l-3.87-1.603c-.13-.053-.275-.053-.404 0-.13.054-.232.157-.286.286L7.87 7.65 5.12 10.963c-.11.134-.148.314-.101.481l1.492 5.254c.044.155.156.282.305.343.065.027.134.04.202.04.089 0 .178-.022.257-.066l4.77-2.66c.152-.085.252-.24.269-.412l.4-4.287 1.572-3.796c.112-.27-.016-.578-.285-.69zM11.29 13.57l-3.203 1.786 1.365-3.296c.111-.268-.017-.577-.286-.688-.269-.112-.577.016-.689.285L7.112 14.95 6.11 11.423 8.484 8.56l1.576.653 1.576.653-.346 3.701zm.621-4.73l-2.06-.854-.836-.345 1.2-2.896 2.896 1.2-1.2 2.895zM23 12.639h-6.176c-1.225 0-2.222.996-2.222 2.222 0 1.225.997 2.221 2.222 2.221.644 0 1.167.524 1.167 1.168 0 .643-.523 1.167-1.167 1.167H5.527c-.29 0-.527.236-.527.527 0 .291.236.527.527.527h11.297c1.225 0 2.222-.996 2.222-2.221 0-1.226-.997-2.222-2.222-2.222-.643 0-1.167-.524-1.167-1.167 0-.644.524-1.168 1.167-1.168H23V12.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignedScheduleA);
export default __webpack_public_path__ + "static/media/signedScheduleA.851eedd802017f7d80b4d016ee09055d.svg";
export { ForwardRef as ReactComponent };